<div *ngIf="task; else noTask" class="p-2" style="min-height: 770px">
  <div *ngIf="bDeleted" class="alert alert-danger">
    Task is no longer available (do not edit)
  </div>
  <ng-container *ngrxLet="selectedPointState$ as selectedPointState">
    <div class="pb-0 d-flex flex-row justify-content-between">
      <div class="py-2 d-flex flex-row">
        <div class="d-flex flex-row align-top header-title">
          <div>Mobile {{ task.type | titlecase }}</div>
          <div class="mx-1">-</div>
          <div>{{ task.stage }}</div>
          <div class="mx-1">-</div>
          <div role="button" (click)="onShowBuilding()">
            <div>{{ task.buildingId }}</div>
            <div class="text-muted sub-title">Building</div>
          </div>
          <div class="mx-1">-</div>
          <div role="button" (click)="onShowVolunteer()">
            <div>{{ task.volunteerName | titlecase }}</div>
            <div class="text-muted sub-title">Mobile User</div>
          </div>
        </div>
        <div class="btn-group px-1 pt-1 pb-sm-3 text-nowrap align-top" dropdown>
          <a
            id="edit-options-btn"
            href="javascript:false;"
            behavior="button"
            dropdownToggle
            class="dropdown-toggle"
            aria-controls="dropdown-edit-options"
          >
            <span class="caret"></span>
          </a>
          <ul
            style="z-index: 9999; min-width: 3rem"
            id="dropdown-edit-options"
            *dropdownMenu
            class="p-1 dropdown-menu"
            role="menu"
            aria-labelledby="edit-options-btn"
          >
          <ng-container *ngIf="!pointTabMode">
            <li role="menuitem" style="margin-bottom: 2px; margin-top: 2px">
              <button
                class="btn btn-secondary w-100 text-left"
                style="border-radius: 0"
                [disabled]="!roleMgr.canEditPointTests"
                (click)="onShowEditModal()"
              >
                <i class="fa fa-edit mr-1"></i>
                Edit
              </button>
            </li>
            <li role="menuitem">
              <button
                class="btn btn-danger w-100 text-left"
                style="border-radius: 0"
                [disabled]="!roleMgr.canEditPointTests"
                (click)="onDeleteTask()"
              >
                <i class="fa fa-trash mr-1"></i>
                Delete
              </button>
            </li>
          </ng-container>
          <ng-container *ngIf="pointTabMode">
            <li role="menuitem">
              <button
                class="btn btn-danger w-100 text-left"
                style="border-radius: 0"
                [disabled]="!roleMgr.canEditPointTests"
                (click)="onDeleteSelectedTaskPoint()"
              >
                <i class="fa fa-trash mr-1"></i>
                Delete Task Point ({{selectedTaskPoint.pointId}})
              </button>
            </li>
          </ng-container>
        </ul>
        </div>
      </div>
      <div
        *ngIf="pointTabMode"
        class="d-flex flex-row justify-content-between point-tab-header"
      >
        <div class="header-title my-auto px-2 w-100">
          <div class="d-flex flex-row justify-content-between">
            <div>
              <button class="btn btn-sm btn-secondary"
              [disabled]="taskPoints.length && selectedTaskPoint === taskPoints[0]"
              (click)="onTaskPointSelected(taskPoints[0])">
                <i class="fa fa-fast-backward"></i>
              </button>
              <button class="btn btn-sm btn-secondary mx-2"
                [disabled]="taskPoints.length && selectedTaskPoint === taskPoints[0]"
                (click)="onRelativeTaskPointSelected(-1)">
                <i class="fa fa-step-backward"></i>
              </button>
            </div>
            <div class="my-auto text-center" style="min-width: 8em;">
            {{ selectedPointState?.taskPoint?.pointId }}
            </div>
            <div>
              <button class="btn btn-sm btn-secondary mx-2"
                [disabled]="taskPoints.length && selectedTaskPoint === taskPoints[taskPoints.length-1]"
                (click)="onRelativeTaskPointSelected(1)">
                <i class="fa fa-step-forward"></i>
              </button>
              <button class="btn btn-sm btn-secondary"
              [disabled]="taskPoints.length && selectedTaskPoint === taskPoints[taskPoints.length-1]"
              (click)="onTaskPointSelected(taskPoints[taskPoints.length-1])">
                <i class="fa fa-fast-forward"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="mt-2 mr-3 text-secondary" style="font-size: larger">
          <i
            role="button"
            class="fa fa-window-close"
            (click)="togglePointTab()"
          ></i>
        </div>
      </div>
    </div>
    <div *ngIf="pointTabMode" class="point-tab-content">
      <app-volunteer-task-point #taskPointComponent
        [task]="task"
        [volunteerTaskPoint]="selectedPointState?.taskPoint"
        [scoutInfo]="selectedPointState?.scoutInfo"
        [mapPoint]="selectedPointState?.mapPoint"
        [mapPoints]="mapPoints"
        (pointSelected)="onMapPointSelected($event)"
        (taskPointModified)="onTaskPointModified($event)"
        [config]="taskConfig.testPoint"
        [correlationVisible]="correlationVisible"
      >
    </app-volunteer-task-point>
    </div>
    <div *ngIf="!pointTabMode" class="d-flex flex-column flex-xl-row busy-overlay-parent"
      [ngClass]="initialEditTaskPointId ? 'disabled' : ''">
      <div
        *ngIf="initialEditTaskPointId"
        class="font-weight-bold busy-overlay"
      >
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Opening test point...
      </div>
      <div class="d-flex flex-column" style="min-width: 610px" #leftDiv>
        <app-volunteer-task-points
          *ngIf="task.taskPoints?.length"
          [task]="task"
          [readonly]="bDeleted"
          [tempHack]="processingPoints"
          [localContext]="localContext"
          [selectedRec]="selectedPointState?.taskPoint"
          [stage]="task.stage"
          [loadTrigger]="pointsTableLoadTrigger"
          (contextJsonChange)="taskPointsContextChanged($event)"
          (taskPointIdClick)="onTaskPointIdClick($event)"
          (taskPointEditClick)="onTaskPointEditClick($event)"
          (taskPointsChanged)="onTaskPointsChanged($event)"
        >
        </app-volunteer-task-points>
        <div class="py-1">
          <div class="row px-3">
            <span class="gray font-italic pl-2">Notes</span>
            <textarea
              (dblclick)="editNotes()"
              [disabled]="bDeleted || !roleMgr.canEditTasks"
              [readonly]="notesFieldDisabled"
              [(ngModel)]="notes"
              (ngModelChange)="notesChangeFn($event)"
              rows="4"
              class="form-control"
              style="resize: none"
            ></textarea>
          </div>
        </div>

        <div *ngIf="isNotesSaveButtonShown" class="d-flex flex-row justify-content-end pb-2">
          <button
            class="btn btn-secondary btn-sm small"
            (click)="onSaveNotes()"
            [disabled]="!notesFieldDirty"
          >
            Save
          </button>
          &nbsp;
          <button
            class="btn btn-secondary btn-sm small"
            (click)="onCancel()"
          >
            Cancel
          </button>
        </div>

        <div class="row px-2">
          <app-path-test-log
            #pathTestLog
            class="w-100" style="margin-bottom: -8px;"
            [contentEditable]="!bDeleted"
            [testId]="getVolunteerId()"
          ></app-path-test-log>
        </div>
      </div>
      <div
        class="d-flex flex-column flex-fill ml-xl-3 mb-2 map-container-size"
      >
        <div class="flex-grow-1" *ngIf="!processingPoints">
          <app-volunteer-task-map
            #taskMap
            [volunteerTask]="task"
            [mapPoints]="mapPoints"
            [selectedMapPoint]="selectedPointState?.mapPoint"
            (pointSelected)="onMapPointSelected($event)"
            [miscLeafNodeEventFn]="onMiscLeafNodeEvent"
            [bInfoMarkersVisible]="!correlationVisible"
          >
          </app-volunteer-task-map>
        </div>
        <app-map-point-summary [mapPoint]="selectedPointState?.mapPoint">
        </app-map-point-summary>
        <!--
        <app-time-window></app-time-window>
        -->
      </div>
    </div>

    <div *ngIf="task?.type === 'test'" class="mt-1">
      <div [ngClass]="pointTabMode && 'd-none'">
        <div class="d-inline-flex mb-2">
        <table class="table table-sm my-0 w-0">
          <tr>
            <th role="button" (click)="toggleCorrelationVisible()" style="width: 10em;">
              Correlation
              <i class="ml-1 fa {{correlationVisible?'fa-chevron-down':'fa-chevron-right'}}"></i>
            </th>
          </tr>
        </table>
        </div>
        <ng-container *ngIf="!loading&&correlationVisible">
          <ng-template #correlationCellRendererTmpl let-record="record" let-column="column"
            let-tableComponent="tableComponent" let-showRequestFn="showRequestFn">
            <td fes-correlation-table-cell-renderer [record]="record" [column]="column" [tableComponent]="tableComponent" (showRequest)="showRequestFn($event)">
            </td>
          </ng-template>
          <app-correlation-table #correlationTable class="mt-1"
          [alternateViewsEnabled]="false"
          [pageSize]="1000"
          (recordsLoaded)="onCorrelationRecordsLoaded($event)"
          [loadOnInit]="true"
          [contextJson]="correlationContext"
          (contextJsonChange)="correlationContext=$event"
          [cellRendererTmplRef]="correlationCellRendererTmpl"
          (rowMouseOverEmitter)="correlationRowHover($event,true)"
          (rowMouseOutEmitter)="correlationRowHover($event,false)">
          </app-correlation-table>
        </ng-container>
      </div>

      <div class="p-0" *ngFor="let scoutSource of scoutSources">
        <app-path-scout-source
          *ngIf="scoutSource.scoutPath"
          [bTabSelected]="bTabActive"
          [pathId]="scoutSource.pathId"
          [stage]="task.stage"
          [selectedPointId]="
            selectedPointState?.taskPoint?.pointId ||
            selectedPointState?.mapPoint?.pointId
          "
          [buildingId]="scoutSource.scout.buildingId"
          [title]="'Scout ' + scoutSource.pathId"
        >
        </app-path-scout-source>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #noTask>
  <div *ngIf="loading"><i class='fa fa-spinner fa-spin mr-2'></i>Loading...</div>
  <div *ngIf="!loading" class="text-danger">Volunteer task missing or failed loading</div>
  <div *ngIf="errorMsg" class="alert alert-danger">
    {{ errorMsg }}
  </div>
</ng-template>
